import cn from "app/utils/classnames";

interface ClipLengthButtonProps {
  onClick: () => void;
  selected: boolean;
  children: React.ReactNode;
}

export default function ClipLengthButton(props: ClipLengthButtonProps) {
  return (
    <button
      className={cn(
        "text-xs uppercase font-mono",
        "pl-1 pr-1",
        props.selected
          ? "font-semibold bg-gray-200"
          : " cursor-pointer",
      )}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}
